// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/gateway/web/possibilities/v1/possibilities_api.proto (package gdx.gateway.web.possibilities.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BatchGetPackagesRequest, BatchGetPackagesResponse, GetPackageRequest, GetPackageResponse, ListPossibilityStateRequest, ListPossibilityStateResponse, PurchasePossibilityRequest, PurchasePossibilityResponse } from "./possibilities_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Contains methods related to possibilities application and its counters.
 *
 * @generated from service gdx.gateway.web.possibilities.v1.PossibilitiesAPI
 */
export const PossibilitiesAPI = {
  typeName: "gdx.gateway.web.possibilities.v1.PossibilitiesAPI",
  methods: {
    /**
     * List possibility state.
     *
     * @generated from rpc gdx.gateway.web.possibilities.v1.PossibilitiesAPI.ListPossibilityState
     */
    listPossibilityState: {
      name: "ListPossibilityState",
      I: ListPossibilityStateRequest,
      O: ListPossibilityStateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get package info.
     *
     * @generated from rpc gdx.gateway.web.possibilities.v1.PossibilitiesAPI.GetPackage
     */
    getPackage: {
      name: "GetPackage",
      I: GetPackageRequest,
      O: GetPackageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Batch get packages info.
     *
     * @generated from rpc gdx.gateway.web.possibilities.v1.PossibilitiesAPI.BatchGetPackages
     */
    batchGetPackages: {
      name: "BatchGetPackages",
      I: BatchGetPackagesRequest,
      O: BatchGetPackagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Purchase possibility.
     *
     * @generated from rpc gdx.gateway.web.possibilities.v1.PossibilitiesAPI.PurchasePossibility
     */
    purchasePossibility: {
      name: "PurchasePossibility",
      I: PurchasePossibilityRequest,
      O: PurchasePossibilityResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

